import { ComponentsTranslation } from '@/assets/locales/components/components.translation.en.ts';
import { componentsTranslation } from '@/assets/locales/components/components.translation.pl.ts';
import {
  dictionariesTranslation,
  DictionariesTranslation,
} from '@/assets/locales/dictionaries/dictionaries.translations.pl.ts';
import {
  errorsTranslation,
  ErrorsTranslation,
} from '@/assets/locales/errors/errors.translation.pl.ts';
import { GeneralErrorTranslation } from '@/assets/locales/generalError/generalError.translation.en.ts';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.pl.ts';
import { MenuTranslation } from '@/assets/locales/menu/menu.translation.en.ts';
import { menuTranslation } from '@/assets/locales/menu/menu.translation.pl.ts';
import { PageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { pageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.pl.ts';
import { TopBarTranslation } from '@/assets/locales/topBar/topBar.translation.en.ts';
import { topBarTranslation } from '@/assets/locales/topBar/topBar.translation.pl.ts';
import { utilsTranslation, UtilsTranslation } from '@/assets/locales/util/utils.translation.pl.ts';
import {
  validationTranslation,
  ValidationTranslation,
} from '@/assets/locales/validation/validation.translation.pl.ts';

import { ViewsTranslation } from './views/views.translation.en.ts';
import { viewsTranslation } from './views/views.translation.pl.ts';

export interface Translations {
  [I18N_NAMESPACE: string]: {
    components: ComponentsTranslation;
    dictionaries: DictionariesTranslation;
    errors: ErrorsTranslation;
    generalError: GeneralErrorTranslation;
    menu: MenuTranslation;
    pageTitles: PageTitlesTranslation;
    topBar: TopBarTranslation;
    utils: UtilsTranslation;
    validation: ValidationTranslation;
    views: ViewsTranslation;
  };
}

export const I18N_NAMESPACE = 'jm';

export const pl: Translations = {
  [I18N_NAMESPACE]: {
    components: componentsTranslation,
    dictionaries: dictionariesTranslation,
    errors: errorsTranslation,
    generalError: generalErrorTranslation,
    menu: menuTranslation,
    pageTitles: pageTitlesTranslation,
    topBar: topBarTranslation,
    utils: utilsTranslation,
    validation: validationTranslation,
    views: viewsTranslation,
  },
};
